import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _c917f588 = () => interopDefault(import('../pages/404.vue' /* webpackChunkName: "" */))
const _b3d32bfa = () => interopDefault(import('../pages/forgotPass/index.vue' /* webpackChunkName: "" */))
const _7a1054be = () => interopDefault(import('../pages/game/index.vue' /* webpackChunkName: "" */))
const _69520c5f = () => interopDefault(import('../pages/giftbag/index.vue' /* webpackChunkName: "" */))
const _3dd216e0 = () => interopDefault(import('../pages/giftbagDetail/index.vue' /* webpackChunkName: "" */))
const _4d96bf9e = () => interopDefault(import('../pages/grade/index.vue' /* webpackChunkName: "" */))
const _62db20b0 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "" */))
const _9706930a = () => interopDefault(import('../pages/realinfo/index.vue' /* webpackChunkName: "" */))
const _514899ac = () => interopDefault(import('../pages/realinfoDetail/index.vue' /* webpackChunkName: "" */))
const _110e2512 = () => interopDefault(import('../pages/register/index.vue' /* webpackChunkName: "" */))
const _345f3a3a = () => interopDefault(import('../pages/user/index.vue' /* webpackChunkName: "" */))
const _474e1364 = () => interopDefault(import('../pages/vip/index.vue' /* webpackChunkName: "" */))
const _77ddccc2 = () => interopDefault(import('../pages/giftbag/components/listDrtail.vue' /* webpackChunkName: "" */))
const _61ee8244 = () => interopDefault(import('../pages/realinfo/components/listDrtail.vue' /* webpackChunkName: "" */))
const _886eb534 = () => interopDefault(import('../pages/user/components/currentThree.vue' /* webpackChunkName: "" */))
const _25678586 = () => interopDefault(import('../pages/user/components/mobilePhone1.vue' /* webpackChunkName: "" */))
const _27d49448 = () => interopDefault(import('../pages/user/components/password.vue' /* webpackChunkName: "" */))
const _04ba166e = () => interopDefault(import('../pages/user/components/problem.vue' /* webpackChunkName: "" */))
const _5bd32120 = () => interopDefault(import('../pages/user/tabCenter/cancellation.vue' /* webpackChunkName: "" */))
const _05e310ee = () => interopDefault(import('../pages/user/tabCenter/dataFirst.vue' /* webpackChunkName: "" */))
const _bef37042 = () => interopDefault(import('../pages/user/tabCenter/game.vue' /* webpackChunkName: "" */))
const _333ae9ad = () => interopDefault(import('../pages/user/tabCenter/security.vue' /* webpackChunkName: "" */))
const _9b854654 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404/",
    component: _c917f588,
    name: "404"
  }, {
    path: "/forgotPass/",
    component: _b3d32bfa,
    name: "forgotPass"
  }, {
    path: "/game/",
    component: _7a1054be,
    name: "game"
  }, {
    path: "/giftbag/",
    component: _69520c5f,
    name: "giftbag"
  }, {
    path: "/giftbag/giftbagDetail/",
    component: _3dd216e0,
    name: "giftbagDetail"
  }, {
    path: "/grade/",
    component: _4d96bf9e,
    name: "grade"
  }, {
    path: "/login/",
    component: _62db20b0,
    name: "login"
  }, {
    path: "/realinfo/",
    component: _9706930a,
    name: "realinfo"
  }, {
    path: "/realinfo/detail/",
    component: _514899ac,
    name: "realinfoDetail"
  }, {
    path: "/register/",
    component: _110e2512,
    name: "register"
  }, {
    path: "/user/",
    component: _345f3a3a,
    name: "user"
  }, {
    path: "/vip/",
    component: _474e1364,
    name: "vip"
  }, {
    path: "/giftbag/listDrtail/",
    component: _77ddccc2,
    name: "giftbag-components-listDrtail"
  }, {
    path: "/realinfo/listDrtail/",
    component: _61ee8244,
    name: "realinfo-components-listDrtail"
  }, {
    path: "/user/currentThree/",
    component: _886eb534,
    name: "user-components-currentThree"
  }, {
    path: "/user/mobilePhone1/",
    component: _25678586,
    name: "user-components-mobilePhone1"
  }, {
    path: "/user/password/",
    component: _27d49448,
    name: "user-components-password"
  }, {
    path: "/user/problem/",
    component: _04ba166e,
    name: "user-components-problem"
  }, {
    path: "/user/tabCenter/cancellation/",
    component: _5bd32120,
    name: "user-tabCenter-cancellation"
  }, {
    path: "/user/tabCenter/dataFirst/",
    component: _05e310ee,
    name: "user-tabCenter-dataFirst"
  }, {
    path: "/user/tabCenter/game/",
    component: _bef37042,
    name: "user-tabCenter-game"
  }, {
    path: "/user/tabCenter/security/",
    component: _333ae9ad,
    name: "user-tabCenter-security"
  }, {
    path: "/",
    component: _9b854654,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
